import { type DatabaseFieldType } from '@databases/types/database';
import { DatabaseFilterType } from '@databases/types/database/view';

import type { FieldType } from '../field-types';

import { parseTextBasedFromHtml, renderTextBasedExportView } from './textBasedFieldType';

const aiSummaryFieldType: FieldType<DatabaseFieldType.AI_SUMMARY> = {
  supportedFilterTypes: [
    DatabaseFilterType.EQUALS,
    DatabaseFilterType.CONTAINS,
    DatabaseFilterType.EMPTY
  ],

  // AI Summary is registered for safe round-tripping only. Keep import disabled
  // until the field is intentionally exposed through UI/generation flows.
  isCsvImportSupported: false,

  renderExportView: ({ value }) => renderTextBasedExportView(value),

  parseFromHtml: parseTextBasedFromHtml,

  getInitialValue: () => ({ plain: '' }),

  isEmptyValue: ({ value }) => !value.plain,

  isEqualValue: ({ value: value1 }, { value: value2 }) => value1.plain === value2.plain,

  getStringRepresentation: ({ value }) => value.plain
};

export default aiSummaryFieldType;
